import { FC, useRef } from 'react';
import { Player, ControlBar, BigPlayButton } from 'video-react';
import { Box } from '@mui/material';

import 'video-react/dist/video-react.css';

interface Props {
  image?: CVT.MaybeNull<string>;
  video?: CVT.MaybeNull<string>;
  alt: string;
}

export const VideoCoverSection: FC<Props> = ({ image, video, alt }) => {

  const playerRef = useRef<any>(null);

  if (!image && !video) {
    return null;
  }

  return (
    <Box
      height={video ? 'auto' : '30vh'}
      overflow="hidden"
    >
      {video ? (
        <Player
          playsInline
          ref={playerRef}
          src={video}
          poster={image || undefined}
        >
          <BigPlayButton position="left-top"  />
          <ControlBar disableCompletely />
        </Player>
      ) : (
        <img
          src={image as string}
          alt={alt}
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            objectFit: 'cover',
            width: '100%',
            height: '100%',
          }}
        />
      )}
    </Box>
  );
};